import { Controller } from "stimulus";
import axios from "axios";

export default class extends Controller {
  static targets = ["content"];

  connect() {
    this.observarAberturaDoModal();
  }

  observarAberturaDoModal() {
    new MutationObserver((mutations) => {
      if (mutations.some(m => m.attributeName === "aria-hidden" && this.modalAberto())) {
        this.obterTermos();
      }
    }).observe(this.element, { attributes: true });
  }

  modalAberto() {
    return this.element.getAttribute("aria-hidden") === "false";
  }

  async obterTermos() {
    const url = this.element.dataset.url;
    if (!url) return console.error("Nenhuma URL encontrada para carregar os termos!");

    this.exibirLoading();

    try {
      const response = await axios.get(url, { headers: { "X-Requested-With": "XMLHttpRequest" } });
      const modalBody = new DOMParser()
        .parseFromString(response.data, "text/html")
        .querySelector(".modal-body");

      this.contentTarget.innerHTML = modalBody ? modalBody.innerHTML : this.erroCarregamento();
    } catch {
      this.contentTarget.innerHTML = this.erroCarregamento();
    }
  }

  exibirLoading() {
    this.contentTarget.innerHTML = "<p>Carregando termos...</p>";
  }

  erroCarregamento() {
    return "<p class='error'>Erro ao carregar os termos.</p>";
  }
}